export enum Field {
  REQUIRED = "required",
  APPROVAL_DATE = "approvalDate",
  EXPIRATION_DATE = "expirationDate",
  NAME = "name",
  WEBSITE = "website",
}
